import { useEffect } from 'react';

import { useRouter } from 'next/router';

export const useBrowseBrandsLinksViaRouter = () => {
  const router = useRouter();

  useEffect(() => {
    const handleBrowseBrandsLinks = (e: Event) => {
      const link = e.target as HTMLElement;
      const linkHref = link.getAttribute('href') || link.closest('a')?.getAttribute('href');
      if (linkHref) {
        e.preventDefault();
        router.push(linkHref, linkHref);
      }
    };

    const browseBrandsMenuDesktop = document.getElementById(
      'desktop-navigation-item-browse-brands',
    );
    const browseBrandsMenuMobile = document.getElementById('mobile-navigation-item-browse-brands');
    const browseBrandsPanelLink = document.getElementById('brands-panel-see-all-brands');

    browseBrandsMenuDesktop?.addEventListener('click', handleBrowseBrandsLinks);
    browseBrandsMenuMobile?.addEventListener('click', handleBrowseBrandsLinks);
    browseBrandsPanelLink?.addEventListener('click', handleBrowseBrandsLinks);

    return () => {
      browseBrandsMenuDesktop?.removeEventListener('click', handleBrowseBrandsLinks);
      browseBrandsMenuMobile?.removeEventListener('click', handleBrowseBrandsLinks);
      browseBrandsPanelLink?.removeEventListener('click', handleBrowseBrandsLinks);
    };
  }, [router]);
};
